var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8036 4.3459C13.5295 2.14635 11.1481 0.666504 8.42055 0.666504C5.32804 0.666504 2.68046 2.56891 1.58731 5.26575M12.5656 5.26575H16.25V1.58635M2.11305 11.7047C3.38717 13.9042 5.76858 15.3841 8.49611 15.3841C11.5886 15.3841 14.2362 13.4817 15.3294 10.7848M4.35111 10.7848H0.666667V14.4642",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1626a61cc252a8a48d4fcd6603a46de6.svg";
export { ForwardRef as ReactComponent };